 
<div class="custom-newsletter d-flex flex-column justify-content-start align-items-stretch h-100 w-100">
    
    <div mat-dialog-title class="custom-newsletter-title d-flex flex-row justify-content-center align-items-center mb-0 p-2">
        <div class="flex-grow-1">
            <span class="fs-4" [innerHTML]="title"></span>
        </div>
        <div>
            <button mat-icon-button (click)="closeDialog()">
                <span class="material-icons fs-1">disabled_by_default</span>
            </button>
        </div>
    </div>

    <div mat-dialog-content class="flex-grow-1 m-0 p-3">

        <p [innerHTML]="content"></p>
        <mat-form-field class="w-100 mb-2" appearance="outline">
            <mat-label>Correo electrónico</mat-label>
            <input matInput  type="email" [formControl]="mailFormControl" required>
            <mat-error *ngIf="mailFormControl.errors?.required">Introduzca una dirección de correo electrónico.</mat-error>
            <mat-error *ngIf="mailFormControl.errors?.email">Introduzca una dirección de correo electrónico válida.</mat-error>
        </mat-form-field>
        <mat-checkbox class="w-100 d-flex flex-row justify-content-start align-items-start mb-2"
            [checked]="lopdChecked"
            (change)="lopdChecked = !lopdChecked">
            <span class="text-wrap" [innerHTML]="authorization"></span>
        </mat-checkbox>
        <p class="custom-newsletter-lopd lh-base" [innerHTML]="lopd"></p>

    </div>

    <div mat-dialog-actions class="d-flex flex-row justify-content-center align-items-center w-100 m-0 p-0">
        <div class="d-grid gap-2 w-100">
            <button mat-flat-button class="custom-newsletter-button p-3" 
                [disabled]="!lopdChecked ||mailFormControl.invalid"    
                (click)="subscribeToNewsletter()">
                <span class="material-icons">email</span>
                Quiero enterarme de todo
            </button>
        </div>
    </div>

</div>


